import { AccountSearchInput, FilterType, SlideAction, useSlideLayout, ViewMode } from '@gripp/shared-ui';
import { Pressable, StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { AddButton } from '../../shared/components/addButton/addButton';
import { FilterBar } from '../../shared/components/filter/filterBar';

export const AccountsFilters = () => {
  const navigate = useNavigate();
  const { currentViewMode, onSlideChange } = useSlideLayout();

  const onInviteNavigate = async () => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }

    navigate(`/account/invite`);
  }

  return (
    <View style={styles.filtersContainer}>
      <View style={styles.searchContainer}>
        <AccountSearchInput />
      </View>
      <FilterBar
        filterButtonTypes={[
          FilterType.ACCOUNTGROUPS,
          FilterType.ACCOUNTTYPES,
          FilterType.ACCOUNTCOLUMNS,
        ]}
      />
      <Pressable>
        <AddButton onPress={onInviteNavigate} />
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  searchContainer: {
    width: 300,
    marginRight: 20,
  },
});
